import router from "@/router"

export const SENSITIVE_APPROVAL_LIST_PATH = "/operation-approval/index"

export function openSensitiveApprovalList() {
  return router.push(SENSITIVE_APPROVAL_LIST_PATH)
}
